var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.9158V7.08457L13.2 10.0002L8 12.9158Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5781 5.32346C19.4643 4.91271 19.2414 4.53821 18.9318 4.23743C18.6222 3.93665 18.2367 3.72014 17.8139 3.60958C16.2568 3.2002 10 3.2002 10 3.2002C10 3.2002 3.74319 3.2002 2.18613 3.60958C1.76333 3.72014 1.37783 3.93665 1.06822 4.23743C0.758609 4.53821 0.535749 4.91271 0.421943 5.32346C0.131206 6.86614 -0.00988125 8.43191 0.000537425 10.0002C-0.00988125 11.5685 0.131206 13.1343 0.421943 14.6769C0.535749 15.0877 0.758609 15.4622 1.06822 15.763C1.37783 16.0637 1.76333 16.2802 2.18613 16.3908C3.74319 16.8002 10 16.8002 10 16.8002C10 16.8002 16.2568 16.8002 17.8139 16.3908C18.2367 16.2802 18.6222 16.0637 18.9318 15.763C19.2414 15.4622 19.4643 15.0877 19.5781 14.6769C19.8688 13.1343 20.0099 11.5685 19.9995 10.0002C20.0099 8.43191 19.8688 6.86614 19.5781 5.32346ZM8.00011 12.9145V7.08591L13.1927 10.0002L8.00011 12.9145Z",
    fill: "#FC0100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.f2afb840801a444d14c11466ae8a06ae.svg";
export { ForwardRef as ReactComponent };